import { Box, LinearProgress, Typography } from "@mui/material";
import { IWithClassName } from "../../../theme/default.theme";
import { RunStatus } from "../enum/run-status";
import { IListBuilderTableDto } from "../interface/dto/list-builder-table-list.dto";

interface IOwnProps {
    listBuilder: IListBuilderTableDto;
}

export const ListBuilderStatus = ({
    className,
    listBuilder,
}: IWithClassName & IOwnProps) => {
    const isRunning = listBuilder.lastRunStatus === RunStatus.Running;
    const progressText = `Status: ${Math.round(
        listBuilder.lastRunProgress ?? 0,
    )}%`;

    return (
        <Box component="span" className={className}>
            {!isRunning && (
                <Typography component="span">
                    {listBuilder.lastRunStatusText}
                </Typography>
            )}
            {isRunning && (
                <Box component="span" className="progress-container">
                    <LinearProgress
                        className="progress-bar"
                        variant="determinate"
                        value={listBuilder.lastRunProgress}
                    />
                    <Typography
                        component="span"
                        variant="caption"
                        className="progress-text"
                    >
                        {progressText}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default ListBuilderStatus;
